module.exports = __webpack_public_path__ + "static/media/waves.e16009ad.svg";